// Footer.jsx
import React, { useContext } from "react";
import { MapPin, Mail, Phone } from "lucide-react";
import { HashLink as Link } from "react-router-hash-link";
import { AppContext } from "./AppContext";

const Footer = () => {
    const { settings } = useContext(AppContext);

    const { brandName, email, phone, address, linkedin, facebook, instagram } = settings || {};

    const socialLinks = [];
    if (linkedin) socialLinks.push({ label: "LinkedIn", href: linkedin, target: "_blank" });
    if (facebook) socialLinks.push({ label: "Facebook", href: facebook, target: "_blank" });
    if (instagram) socialLinks.push({ label: "Instagram", href: instagram, target: "_blank" });

    const usefulLinks = [
        { label: "Home", href: "/#" },
        { label: "Our Services", href: "/#services" },
        { label: "Testimonials", href: "/#testimonials" },
        { label: "About Us", href: "/#about" },
        { label: "Book Consultation", href: "/#book-consultation" },
        { label: "Get in Touch", href: "/#contact" },
    ];

    return (
        <footer className="relative bg-[var(--text-primary)] text-[var(--muted)] px-6 lg:px-20 pt-10 pb-6 overflow-hidden">
            <div className="max-w-7xl mx-auto relative z-10 flex flex-col md:flex-row justify-between gap-10">
                {/* Contact / Brand Info (33%) */}
                {/* Contact / Brand Info */}
                <div className="md:w-1/2 flex flex-col items-start gap-2 group cursor-pointer max-w-md">

                    {brandName && (
                        <div className="inline-flex items-center gap-3 mb-2 min-w-0">
                            {/* Logo: fixed height, won't grow, block to remove inline whitespace */}
                            <img
                                src="/assets/images/logo.png"
                                alt="Gantavyam Logo"
                                className="h-[12rem] w-auto object-contain block flex-shrink-0"
                                style={{ display: "block" }}
                            />

                            {/* Brand name: no extra leading, no wrap */}
                            {/*<div>
                                <h2 className="text-[#e96a1e] text-xl font-semibold leading-none whitespace-nowrap">
                                    {brandName}
                                </h2>
                                <p className="-mt-1 text-[#ffffff] ">Your Wealth Doctor</p>
                            </div> */}
                        </div>
                    )}

                    {address && (
                        <div className="flex items-start gap-2 text-sm text-[var(--bg-surface)] leading-relaxed">
                            <MapPin className="flex-shrink-0 mt-[2px]" size={18} />
                            <span>{address}</span>
                        </div>
                    )}

                    {email && (
                        <a
                            href={`mailto:${email}`}
                            className="flex items-center gap-2 text-sm text-[var(--bg-surface)] hover:text-[var(--color-primary)] hover:no-underline transition-colors"
                        >
                            <Mail size={18} className="flex-shrink-0" />
                            <span>{email}</span>
                        </a>
                    )}

                    {phone && (
                        <a
                            href={`tel:${phone}`}
                            className="flex items-center gap-2 text-sm text-[var(--bg-surface)] hover:no-underline hover:text-[var(--color-primary)] transition-colors"
                        >
                            <Phone size={16} className="flex-shrink-0" />
                            <span>{phone}</span>
                        </a>
                    )}
                </div>


                {/* Useful Links (33%) */}
                <div className="md:w-1/4 flex flex-col items-start text-left">
                    <h3 className="text-[var(--bg-surface)] text-sm font-semibold mb-2">Useful Links</h3>
                    <ul className="space-y-1">
                        {usefulLinks.map((item) => (
                            <li key={item.label}>
                                <Link
                                    to={item.href}
                                    smooth
                                    className="transition-all text-sm duration-300 hover:no-underline hover:text-[var(--color-primary)] text-[var(--muted)]"
                                >
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Follow Us (33%) */}
                <div className="md:w-1/4 flex flex-col items-start text-left">
                    <h3 className="text-[var(--bg-surface)] text-sm font-semibold mb-2">Follow Us</h3>
                    <div className="flex flex-col space-y-1">
                        {socialLinks.length > 0 ? (
                            socialLinks.map((s) => (
                                <a
                                    key={s.label}
                                    href={s.href}
                                    target={s.target || "_blank"}
                                    rel={s.target ? "noreferrer" : undefined}
                                    className="transition-all text-sm duration-300 hover:no-underline hover:text-[var(--color-primary)] text-[var(--muted)]"
                                >
                                    {s.label}
                                </a>
                            ))
                        ) : (
                            <p className="text-xs text-[var(--muted)/80]">No social links provided.</p>
                        )}
                    </div>
                </div>
            </div>

            {/* Divider + Centered Copyright */}
            <div className="relative border-t border-gray-800 mt-6 pt-4">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-px bg-gradient-to-r from-transparent via-gray-400 to-transparent opacity-50" />
                <div className="flex items-center justify-center text-sm text-[var(--muted)/80]">
                    <p className="text-xs text-[var(--text-disabled)] text-center">
                        Copyright © 2025 {brandName || ""} All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
